export default __webpack_public_path__ + "static/media/toyota-full.539fa5e7.png";